import { useQuery } from '@tanstack/react-query';
import { getPatientMedicalDocumentRecord } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const useMedicalDocumentQuery = (patientId: string, medicalDocumentId: string, opts?: BaseQueryOpts) => {
  return useQuery([ 'user', patientId, 'document', medicalDocumentId ], async () => {
    const downloadLinkResponse = await getPatientMedicalDocumentRecord(patientId, medicalDocumentId);

    return downloadLinkResponse.data;
  }, opts);
};
